module.exports = __webpack_public_path__ + "static/media/mobil_adat.7c078f6c.png";